// Admin SubNav Component
import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';

interface SubNavItem {
  key: string;
  label: string;
  count?: number;
}

interface AdminSubNavProps {
  items: SubNavItem[];
  activeItem: string;
  onItemChange: (key: string) => void;
  brand: BrandConfig;
}

const AdminSubNav: React.FC<AdminSubNavProps> = ({ items, activeItem, onItemChange, brand }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="border-b" style={{ borderColor: brand.colors.border }}>
      <ul className="flex gap-1 px-4">
        {items.map((item) => (
          <li key={item.key}>
            <button
              className="px-4 py-3 text-sm font-medium transition-all relative"
              onClick={() => onItemChange(item.key)}
              style={{
                color: activeItem === item.key ? brand.colors.link : brand.colors.textLight,
              }}
            >
              {item.label}
              {item.count !== undefined && (
                <span
                  className="ml-2 px-2 py-0.5 text-xs rounded-full"
                  style={{
                    backgroundColor: activeItem === item.key ? brand.colors.primaryLight : brand.colors.bgLight,
                    color: activeItem === item.key ? brand.colors.link : brand.colors.textLight,
                  }}
                >
                  {item.count}
                </span>
              )}
              {activeItem === item.key && (
                <div
                  className="absolute bottom-0 left-0 right-0 h-0.5"
                  style={{ backgroundColor: brand.colors.primary }}
                />
              )}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AdminSubNav;
